'use client';

import React from 'react';

import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { Select } from '@/components/Select';
import { type ProductExtendedSizes } from '@/modules/product/aliases';
import { isSold } from '@/modules/product/helpers/isSold';

type Props = {
  sizes?: ProductExtendedSizes;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  value: string;
};

export function SizeSelect({ sizes = [], onChange, value }: Props) {
  const t = useTranslations('product');

  return (
    <Select
      className={styles.sizeSelect}
      label={t('ChooseSize')}
      onChange={onChange}
      value={value}
    >
      <option value="" disabled>
        {t('ChooseSize')}
      </option>
      {sizes.map((size) => (
        <option
          key={size.id}
          value={size.id}
          disabled={size.quantity < 1 || isSold(size.status)}
        >
          {isSold(size.status) ? `${size.name} - ${t('Sold')}` : size.name}
        </option>
      ))}
    </Select>
  );
}
